import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=258ed4d0&"
import script from "./IconCard.vue?vue&type=script&lang=ts&"
export * from "./IconCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports